import { render, staticRenderFns } from "./SelfStudyLesson.vue?vue&type=template&id=8b57398a&scoped=true&"
import script from "./SelfStudyLesson.vue?vue&type=script&lang=js&"
export * from "./SelfStudyLesson.vue?vue&type=script&lang=js&"
import style0 from "./SelfStudyLesson.vue?vue&type=style&index=0&id=8b57398a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b57398a",
  null
  
)

export default component.exports